export const OBJECT_REVIEW_LABEL = 'In Prüfung'

export const OBJECT_REVIEW_TOOLTIP = 'Objekt befindet sich aktuell in Überprüfung'

export const OBJECT_REVIEW_HINT = 'Dieser Eintrag befindet sich in Prüfung. Sie können weiterhin Änderungen vornehmen und speichern.'

export function isObjectInReview(object) {
  return !!object?.needs_review
}
